angular.module('impactx.user')
    .directive('ixContactUser', ['$context', function($context) {
        return {
            scope: {
                user: "="
            },
            restrict: 'E',
            templateUrl: 'shared/user/templates/contactuser.tmpl.html',
            transclude: true,
            link: function (scope) {
                scope.contextUserId = $context.userId.value;
            }
        };
    }]);